import React from "react";
import { Spinner } from "@heroui/react";

/**
 * Fallback component shown during lazy route loading
 * Optimized for production with minimal overhead
 */
const RouteLoadingFallback: React.FC = () => {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50 dark:from-slate-900 dark:to-slate-800">
      <div className="flex flex-col items-center gap-4">
        <Spinner size="lg" color="primary" />
        <p className="text-sm text-gray-600 dark:text-gray-400">Loading...</p>
      </div>
    </div>
  );
};

export default RouteLoadingFallback;
